import Tabs from '@/js/tabs.js';

class TabbedInformation extends Tabs {}

customElements.get('tabbed-information-js-tabs') ||
  customElements.define('tabbed-information-js-tabs', TabbedInformation);
